import React, { useState } from "react";
import MainModal from './General/MainModal';
import InfoCalculadora from "./Calculadora/InfoCalculadora";
import CalculadoraService from "../services/calculadora";
import Swal from 'sweetalert2';

export const Calculadora = (props) => {

  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [peso, setPeso] = useState("");
  const [precio, setPrecio] = useState("");
  const [cotizacion, setCotizacion] = useState("");

  const handlePesoChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setPeso(value);
    }
  };

  const handlePrecioChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setPrecio(value);
    }
  };

  const handleSubmit = async () => {
    if (!peso || !precio) {
      Swal.fire({
        title: 'Campos incompletos',
        text: 'Por favor, ingrese el peso y el precio antes de cotizar.',
        icon: 'warning',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    handleOpen();
   /* try {
      const data = await CalculadoraService.obtenerCotizacion(peso, precio);
      setCotizacion(data);
      Swal.fire({
        title: '¡Cotización exitosa!',
        text: `La cotización se calculó correctamente.`,
        icon: 'success',
        confirmButtonText: 'Aceptar'
      });
      handleOpen();  // Abre el modal con la cotización
    } catch (error) {
      Swal.fire({
        title: 'Error al cotizar',
        text: 'Hubo un problema al realizar la cotización. Por favor, intenta de nuevo.',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
    }*/
  };
  

  return (
    <div id="calculadora">
       <MainModal
        size={"xs"}
        open={open}
        handleClose={() => {
         // cleanInfo();
         handleClose();
        }}
       // formSubmit={saveShift}
        //centrado={'centrado'}
        title={""}
        subTitle={""}
        bodyModal={
          <InfoCalculadora
            cotizacion={cotizacion}
          />
        }
      />
      <div className="container">
        <div className="section-title text-center">
          <h2>Calculadora</h2>
        </div>
        <div className="row">
          <div className="col-md-5 col-md intro-text">
            <h4>Ingrese peso</h4>
            <input
              type="text"
              className="form-control"
              placeholder="Ingrese peso en kg"
              value={peso}
              onChange={handlePesoChange}
            />
          </div>
          <div className="col-md-5 col-md intro-text">
            <h4>Ingrese precio</h4>
            <input
              type="text"
              className="form-control"
              placeholder="Ingrese precio"
              value={precio}
              onChange={handlePrecioChange}
            />
          </div>
          <div className="col-md-2" style={{ paddingTop: "3.8rem" }}>
            <button
              className="btn btn-warning"
              type="button"
              onClick={handleSubmit}
            >
              Cotizar GRATIS
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
